export function useIsInIframe() {
    return window.location !== window.parent.location ? true : false; 
}